import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {newGuid, parseOptions} from '../question-helper';
import {Question} from '../../models/underwriter.model';
import { ChangeDetectorRef } from '@angular/core';

declare const $: any;

@Component({
    selector: 'app-question-dropdown',
    templateUrl: './question-dropdown.component.html',
    styleUrls: ['./question-dropdown.component.scss'],
    standalone: false
})
export class QuestionDropdownComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() labelText: string;
  @Input() showLabel = true;
  @Input() showOptionLabel = false;
  @Input() showQuestionCopyLabel = false;
  @Input() readOnly = false;
  @Input() useUiFront = false;
  @Input() controlCssClass: string;
  @Input() options: any[];
  @Input() selectedValue: any;
  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `select-${newGuid()}`;
  uniqueControlId = `select-id-${newGuid()}`;
  skipped = false;
  showSkip = false;
  parameter: any;
  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    try {
      this.parameter = this.question.parameter ? JSON.parse(this.question.parameter) : [];
    } catch {
      this.parameter = [];
    }
    if (Array.isArray(this.parameter)) {
      this.showSkip = this.parameter.some(p => p.parameter === 'show_skip' && p.value === '1');
      if (this.parameter.some(p => p.parameter === 'readOnly' && p.value === '1') && !!this.question?.answer) {
        this.readOnly = true;
      }
    }
    if (this.question && this.question?.options) {

      this.options = parseOptions(this.question.options);

    }
  }

  ngAfterViewInit(): void {
    this.initCustomSelect();

    if (this.options?.length === 1){
      this.question.answer = this.options[0]?.answer;
      this.question.answer_id = this.options[0]?.cent_aq_answer_id;
      this.questionAnswer.emit(this.question);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.options = parseOptions(changes?.question?.currentValue?.options);
      this.cdr.detectChanges();
    }

    if (changes?.options?.currentValue) {
      this.options = changes?.options?.currentValue;
    }

    if (changes?.selectedValue?.currentValue) {
      this.selectedValue = changes?.selectedValue?.currentValue;
    }

    if ($(`#${this.uniqueControlId}`).selectmenu('instance')
      && (changes?.options?.currentValue
        || changes?.question?.currentValue
        || changes?.selectedValue?.currentValue)
    ) {
      setTimeout(() => {
        if (this.selectedValue) {
          $(`#${this.uniqueControlId}`).selectmenu('refresh', true).removeClass('is-placeholder');
        } else {
          $(`#${this.uniqueControlId}`).selectmenu('refresh');
        }
      }, 200);
    }
    
  }

  getValue(option: any): string {
    if (option.hasOwnProperty('value')) {
      return option?.value;
    } else if (option.hasOwnProperty('cent_aq_answer_id')) {
      return option.cent_aq_answer_id;
    } else if (option.hasOwnProperty('rate_id')) {
      return option.rate_id;
    } else if (option.hasOwnProperty('answer')) {
      return option.answer;
    }
    return option;
  }

  getOptionText(option: any): string {
    if (option.hasOwnProperty('label')) {
      return option.label;
    } else if (option.hasOwnProperty('answer')) {
      return option.answer;
    } else if (option.hasOwnProperty('rate_name')) {
      return option.rate_name;
    }
    return option;
  }

  getSelectedOption(option: any): any {
      if ((option.hasOwnProperty('value') && option?.value === this.selectedValue)
        || (option.hasOwnProperty('cent_aq_answer_id') && !!option?.cent_aq_answer_id && option?.cent_aq_answer_id === this.question?.answer_id)
        || (option.hasOwnProperty('answer') && option.answer === this.question?.answer)
        || (option.hasOwnProperty('answer') && option.answer === this.selectedValue)
        || (option.hasOwnProperty('rate_id') && option.rate_id.toString() === this.selectedValue)
        || (option === this.selectedValue)) {
        return option;
      }
      return '';
  }

  initCustomSelect(): void {
    $(`#${this.uniqueControlId}`).selectmenu({
      change: (event, data) => {
        if (data?.item?.value) {
          if (this.question) {
            for (const option of this.options) {
              if (option.hasOwnProperty('value') && option?.value.toString() === data?.item?.value) {
                if (!isNaN(+option?.value)) {
                  this.question.answer_id = option?.value;
                } else {
                  this.question.answer_id = 0;
                }
                this.setQuestionAnswerText(option);
              } else if (option.hasOwnProperty('cent_aq_answer_id') && option?.cent_aq_answer_id.toString() === data?.item?.value) {
                if (!isNaN(+option?.cent_aq_answer_id)) {
                  this.question.answer_id = option?.cent_aq_answer_id;
                } else {
                  this.question.answer_id = 0;
                }
                this.setQuestionAnswerText(option);
              } else if (option.hasOwnProperty('rate_id') && option?.rate_id.toString() === data?.item?.value) {
                if (!isNaN(+option?.rate_id)) {
                  this.question.answer_id = option?.rate_id;
                } else {
                  this.question.answer_id = 0;
                }
                this.setQuestionAnswerText(option);
              } else if (option.hasOwnProperty('answer') && option?.answer === data?.item?.value) {
                this.question.answer_id = 0;
                this.setQuestionAnswerText(option);
              }
            }
            
            this.questionAnswer.emit(this.question);
          } else {
            this.questionAnswer.emit(data?.item?.value);
          }
        }
        else{
          if (this.question) {
            this.question.answer = null;
            this.question.answer_id = 0;
            this.questionAnswer.emit(this.question);
          } else {
            this.questionAnswer.emit(null);
          }
        }
      }
    });
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
  setQuestionAnswerText(option: any): void {
    if (option.hasOwnProperty('label')) {
      this.question.answer = option?.label;
    } else if (option.hasOwnProperty('answer')) {
      this.question.answer = option?.answer;
    } else if (option.hasOwnProperty('rate_name')) {
      this.question.answer = option?.rate_name;
    }
  }

}
